<template>
    <div class="record-report-container">
        <div class="t-top-bar">
            <div class="report-op">
<!--                <el-input placeholder="员工编号、员工姓名" v-model="keyword" class="search-input"></el-input>-->
                <el-cascader class="search-input sd" clearable v-model="searchDepart" placeholder="所属班组" :options="treeData"
                             :props="{ expandTrigger: 'hover', label: 'name',value:'departmentId' }" @change="treeChange"></el-cascader>
<!--              <el-select  class="search-input200" clearable v-model="selectColumn" placeholder="统计数据">-->
<!--                <el-option v-for="(val,key, i) in reportColumn" :key="i" :label="val" :value="key"></el-option>-->
<!--              </el-select>-->
<!--              <el-select  class="search-input200" clearable v-model="pn">-->
<!--                <el-option v-for="(val,key, i) in pns" :key="i" :label="val" :value="key"></el-option>-->
<!--              </el-select>-->
                <el-date-picker  v-model="selectTime" type="daterange" :picker-options="pickerOptions"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right"></el-date-picker>
            </div>
            <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
          <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>
            <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%" :span-method="arraySpanMethod"  height="640" v-loading="listLoading">
          <el-table-column prop="date" label="日期" width="100"></el-table-column>
          <el-table-column prop="production_name" label="原料" width="100"></el-table-column>
          <el-table-column prop="spec_name" width="180" label="规格"></el-table-column>
          <el-table-column prop="" label="件数"></el-table-column>
          <el-table-column prop="" width="180" label="每件净重"></el-table-column>
          <el-table-column prop=""  width="180" label="总数量/斤">
          </el-table-column>
          <el-table-column prop="technology_name" label="加工名称" width="150"></el-table-column>
          <el-table-column prop="spec_name" label="规格" width="100"></el-table-column>
          <el-table-column prop="delivery_kg" label="加工费用">
            <el-table-column prop="" label="数量/斤"></el-table-column>
            <el-table-column prop="delivery_kg" label="核对后数量"></el-table-column>
            <el-table-column prop="" label="单价"></el-table-column>
            <el-table-column prop="" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column prop="" label="加工费用"></el-table-column>
          <el-table-column prop="" label="出成率"></el-table-column>
          <el-table-column prop="" label="核对后数量出入"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { getRecordListProduct } from '../../api/record'
    import {tableDataToExcel, tableDataToExcelV1, tableDataToExcelSample, dataprint} from '../../util/util'
    import { getEquipmentListAll } from '../../api/equipment'
    import { getDepartmentList } from '../../api/department'
    import localCache from "../../util/localCache";
    export default {
        name: "yuxiangProductReport",
        data(){
          function calcSalarySubsidy(sumPrice){
            if(sumPrice >= 5000){
              return sumPrice * 0.1
            }else if(sumPrice >= 4000){
              return sumPrice * 0.09
            }else if(sumPrice >= 3000){
              return sumPrice * 0.08
            }else if(sumPrice >= 2000){
              return sumPrice * 0.07
            }else {
              return 0
            }
          }
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                reportColumn: {
                  'total_price': '工资',
                  // 'calc_kg': '计价重量',
                  // 'delivery_kg': '交料重量'
                },
                selectColumn: 'total_price',
                pns:{
                  '剥虾':'剥虾',
                  '去头':'去头'
                },
                pn: '剥虾',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                selectTime: '',
                keyword: '',
                exportColumn: {
                  'date': {
                    title:'日期',
                    rowspan: 'span'
                  },
                  'production_name': {
                    title: '原料',
                    rowspan: 'span1'
                  },
                  'spec_name': {
                    title: '规格',
                    rowspan: 'span2'
                  },
                  'default': {
                    title: '件数',
                    rowspan: 'span3'
                  },
                  'default1': {
                    title: '每件净重',
                    rowspan: 'span4'
                  },
                  'default2': '总数量/斤',
                  'technology_name': '加工名称',
                  'repeat': {
                    title: '规格',
                    col: 'spec_name'
                  },
                  multiFee: {
                    title: '加工费用',
                    colspan: 4,
                    columns: {
                      'default1': '数量/斤',
                      'delivery_kg': '核对后数量',
                      'default2': '单价',
                      'default3':'金额'
                      },
                  },
                  'default4': '加工费用',
                  'default5': '出成率',
                  'default6': '核对后数量出入',
                },
                subEquipments: [],
                subEquipmentId:'',
                searchDepart:'',
                treeData: [],
                priceType:''
            }
        },
        mounted(){
            let now = new Date()
            let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0).getTime();
            let begin = end - 86400000 * (now.getDate()-1);
            let start = new Date(begin)
            this.selectTime = [start,now]

            this.getRecordList_()
            this.getTree()
        },
        methods: {
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            dataprint(printHTML)
          },
          arraySpanMethod({ row, column, rowIndex, columnIndex }){
            if(row.date=='剥虾合计'){
              if(columnIndex>0 && columnIndex < 5){
                return {
                  rowspan:1,
                  colspan:0
                }
              }
            }
            if(columnIndex == 0){
              if(row.span){
                return row.span
              }
            }else if(columnIndex == 1){
              if(row.span1){
                return row.span1
              }
            }
          },
            exportExcel(){
                let depart = document.querySelector('.sd').querySelector('input').value || ''
                let date = new Date(this.selectTime[0])
                let title = `${depart}${date.getFullYear()}年${date.getMonth()+1}月代加工费`
                // tableDataToExcelV1( this.tableData,title,this.exportColumn,'',{
                //   showTitle: true,
                //   mulTitle: true,
                // })
              let str = document.querySelector('.el-table__header').innerHTML
              let body = document.querySelector('.el-table__body').innerHTML
              console.log(str+body)
              tableDataToExcelSample(str+body,title)
            },
            search(){
                this.getRecordList_()
            },
            getRecordList_(){
                if(!this.selectTime){
                    this.$message.error('请选择开始结束时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  keyword: this.keyword,
                  departmentId:departmentId
                }
                if(param.beginTime == param.endTime){
                  param.endTime += 86400
                }
              getRecordListProduct(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.tableData = this.parseData(res.data)
                        console.log(this.tableData)
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            parseData(data){
              let t
              let d = []
              let o = {}
              let date = {}
              let product = {}
              let sum = 0
              for (let i = 0,len = data.length; i < len; i++) {
                t = data[i]

                let key = t.year+t.month+t.day+t.production_id+t.technology_id+t.spec_id
                if(!o[key]){
                  o[key] = {
                    year: t.year,
                    month: t.month,
                    day: t.day,
                    date: `${t.month}月${t.day}日`,
                    production_id: t.production_id,
                    technology_id: t.technology_id,
                    spec_id: t.spec_id,
                    production_name: t.production_name,
                    technology_name: t.technology_name,
                    spec_name: t.spec_name,
                    delivery_kg: (t.delivery_kg * 2).toFixed(2)
                  }
                  d.push(o[key])
                }
                sum += parseFloat(o[key].delivery_kg)
                let k = ''+t.year+t.month+t.day
                if(!date[k]){
                  date[k] = o[key]
                }else{
                  if(!date[k].span){
                    date[k].span = {
                      rowspan: 2,
                      colspan: 1
                    }
                  }else{
                    date[k].span.rowspan ++
                  }
                  o[key].span = {
                    rowspan: 0,
                    colspan: 0
                  }
                }
                let k1 = ''+t.year+t.month+t.day+t.production_id
                if(!product[k1]){
                  product[k1] = o[key]
                }else{
                  if(!product[k1].span1){
                    product[k1].span1 = {
                      rowspan: 2,
                      colspan: 1
                    }
                  }else{
                    product[k1].span1.rowspan ++
                  }
                  o[key].span1 = {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              }
              d.push({
                date: '剥虾合计',
                delivery_kg: sum.toFixed(2),
                span:{
                  rowspan:1,
                  colspan:5
                },
                span1:{
                  rowspan:1,
                  colspan:0
                },
                span2:{
                  rowspan:1,
                  colspan:0
                },
                span3:{
                  rowspan:1,
                  colspan:0
                }
              })
              return d
            },
          calcSuelSubsidy(daySalary) {
            if(daySalary >= 70){
              return 2
            }
            return 0
          },
          calcSalarySubsidy(sumPrice){
              if(sumPrice >= 5000){
                return sumPrice * 0.1
              }else if(sumPrice >= 4000){
                return sumPrice * 0.09
              }else if(sumPrice >= 3000){
                return sumPrice * 0.08
              }else if(sumPrice >= 2000){
                return sumPrice * 0.07
              }else {
                return 0
              }
          },
            showdata(row, item){
              let o = row[item.prop]
              if(o){
                return o[this.selectColumn]
              }
              return ''
            },
          treeChange(val){
              console.log(this.treeData)

          },
            getTree() {
                getDepartmentList({
                    customerId:localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.treeData = res.data
                    }
                }).catch(() => {
                })
            },
        }
    }
</script>

<style lang="scss">
    .record-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
    }

</style>
